import React from 'react';

const RoomForm = ({ formData, handleInputChange, errors }) => {
  return (
    <>
      {/* Common fields for room */}
      <div className="form-group">
        <label htmlFor="water_source">
          Water Source
        </label>
        <select type="number" id="water_source" name="water_source" value={formData.water_source} onChange={handleInputChange} className="fancy-input" >
          <option value="">Select water source</option>
          <option value="no_water">No Water</option>
          <option value="council_water">Council Water</option>
          <option value="borehole">Borehole Water</option>
        </select>
        {errors.water_source && <div className="error-text">{errors.water_source}</div>}
      </div>
      <div className="form-group">
        <label htmlFor="type_of_bathroom">
          Type of Bathroom
        </label>
        <select
          id="type_of_bathroom"
          name="type_of_bathroom"
          value={formData.type_of_bathroom}
          onChange={handleInputChange}
          required
          className="fancy-input"
        >
          <option value="">Select bathroom type</option>
          <option value="shared">Shared</option>
          <option value="private">Private</option>
        </select>
        {errors.type_of_bathroom && <div className="error-text">{errors.type_of_bathroom}</div>}
      </div>

      <div className="checkboxes">
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input type="checkbox" name="has_power_backup" checked={formData.has_power_backup} onChange={handleInputChange} />
            Has Power Backup
          </label>
          {errors.has_power_backup && <div className="error-text">{errors.has_power_backup}</div>}
        </div>

        {formData.has_power_backup && (
          <div className="form-group">
            <label htmlFor="power_backup">
              Power Backup
            </label>
            <select
              id="power_backup"
              name="power_backup"
              value={formData.power_backup}
              onChange={handleInputChange}
              className="fancy-input"
            >
              <option value="">Backup options</option>
              <option value="solar_power">Solar Power</option>
              <option value="generator">Generator</option>
            </select>
            {errors.power_backup && <div className="error-text">{errors.power_backup}</div>}
          </div>
        )}


        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input type="checkbox" name="is_deposit_required" checked={formData.is_deposit_required} onChange={handleInputChange} />
            Deposit Required
          </label>
          {errors.is_deposit_required && <div className="error-text">{errors.is_deposit_required}</div>}
        </div>

        {formData.is_deposit_required && (
          <div className="form-group">
            <label htmlFor="deposit_amount">
              Deposit Amount
            </label>
          <input
            type="number"
            id="deposit_amount"
            name="deposit_amount"
            value={formData.deposit_amount}
            onChange={handleInputChange}
            className="fancy-input"
          />
          {errors.deposit_amount && <div className="error-text">{errors.deposit_amount}</div>}
          </div>
        )}
      </div>

      <div className="checkboxes">
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_electricity"
              checked={formData.has_electricity}
              onChange={handleInputChange}
            />

            Has Electricity
          </label>
          {errors.has_electricity && <div className="error-text">{errors.has_electricity}</div>}
        </div>
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="is_furnished"
              checked={formData.is_furnished}
              onChange={handleInputChange}
            />
            Furnished
          </label>
          {errors.is_furnished && <div className="error-text">{errors.is_furnished}</div>}
        </div>
      </div>

      <div className="checkboxes">
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="is_gated"
              checked={formData.is_gated}
              onChange={handleInputChange}
            />
            Gated
          </label>
          {errors.is_gated && <div className="error-text">{errors.is_gated}</div>}
        </div>
        
      </div>
    </>
  );
};

export default RoomForm;
